"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformBookmarkApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Operations for creating and deleting bookmarks
 */
class SdPlatformBookmarkApi extends ResourcesApi_1.ResourcesApi {
    /**
     * The resource path.
     */
    get __resourcePath() {
        return "bookmarks";
    }
    /**
     * Create a bookmark for the model for the user identified by @see SdPlatformAuthServiceApi
     * @param body - {@link SdPlatformRequestBookmarkCreate} creae parameters.
     * @returns - {@link SdPlatformPostResponse} with 'success' property being true,
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.BookmarkCreate, body);
    }
    /**
     * Delete a bookmark for the model for the user identified by  @see SdPlatformAuthServiceApi
     * @param id - id of the model whose bookmark shall be deleted
     * @returns - {@link SdPlatformDeleteResponse}
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.BookmarkDelete, id);
    }
}
exports.SdPlatformBookmarkApi = SdPlatformBookmarkApi;
//# sourceMappingURL=SdPlatformBookmarkApi.js.map